<script>
import moment from 'moment'
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import List from './list'

export default {
  page: {
    title: 'Transaksi Proyek',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    List,
  },
  data() {
    return {
      user: this.$store ? this.$store.state.auth.currentUser : {} || {},
      title: 'Transaksi Proyek',
      subtitle: 'Data Transaksi Proyek',
      crumbs: [
        {
          text: 'Home',
          href: '/',
        },
        {
          text: 'OLO',
          active: true,
        },
      ],
      rows: 1,
      perPage: 1,
      currentPage: 1,
      from: 1,
      items: [],
      show: 'table',
      isValid: false,
      save: '',
      url: '/web/transaksi/proyek',
      fields: [
        { key: 'no', label: 'No', sortable: false },
        {
          key: 'kode_proyek',
          label: 'Kode Proyek',
          sortable: false,
        },
        {
          key: 'nama_proyek',
          label: 'Nama Proyek',
          sortable: false,
        },
        {
          key: 'nama_kontrak',
          label: 'Nama Kontrak',
          sortable: false,
          formatter: (value, key, item) => {
            return value.slice(0, 50) + '...'
          },
        },
        {
          key: 'mekanisme_pembayaran',
          label: 'Mekanisme',
          sortable: false,
        },
        {
          key: 'tanggal_mulai',
          label: 'Tanggal Mulai',
          sortable: false,
          formatter: (value, key, item) => {
            moment.locale('id')
            return moment(value).format('DD MMMM YYYY')
          },
        },
        {
          key: 'tanggal_berakhir',
          label: 'Tanggal Berakhir',
          sortable: false,
          formatter: (value, key, item) => {
            moment.locale('id')
            return moment(value).format('DD MMMM YYYY')
          },
        },
        {
          key: 'nilai_kontrak_belum_ppn',
          label: 'Nilai Kontrak Belum PPN',
          sortable: false,
          formatter: (value, key, item) => {
            let val = (value / 1).toFixed(2).replace('.', ',')
            return 'Rp ' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          },
        },
        {
          key: 'sph',
          label: 'SPH',
          sortable: false,
          formatter: (value, key, item) => {
            let val = 0;
            if (item.rab.length > 0) {
              const summary = item.rab.reduce(
                (a, b) =>
                  a +
                  (b['sph'] *
                    (b['sph_kali'] !== 'all'
                      ? b[b['sph_kali']]
                      : b['volume'] * b['periode']) || 0),
                0
              )
              val = summary
            }
            return 'Rp ' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          },
        },
        {
          key: 'spk',
          label: 'SPK',
          sortable: false,
          formatter: (value, key, item) => {
            let val = 0;
            if (item.rab.length > 0) {
              const summary = item.rab.reduce(
                (a, b) =>
                  a +
                  (b['spk'] *
                    (b['spk_kali'] !== 'all'
                      ? b[b['spk_kali']]
                      : b['volume'] * b['periode']) || 0),
                0
              )
              val = summary
            }
            return 'Rp ' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          },
        },
        {
          key: 'margin',
          label: 'Margin',
          sortable: false,
          formatter: (value, key, item) => {
            let val = 0;
            let spk = 0;
            let sph = 0;
            if (item.rab.length > 0) {
              spk = item.rab.reduce(
                (a, b) =>
                  a +
                  (b['spk'] *
                    (b['spk_kali'] !== 'all'
                      ? b[b['spk_kali']]
                      : b['volume'] * b['periode']) || 0),
                0
              )

              sph = item.rab.reduce(
                (a, b) =>
                  a +
                  (b['sph'] *
                    (b['sph_kali'] !== 'all'
                      ? b[b['sph_kali']]
                      : b['volume'] * b['periode']) || 0),
                0
              )
              val = (spk - sph) / sph 
            }
            if (spk === 0)
              return '-'

            return (val * 100).toFixed(1) + "%"
          },
        },
        {
          key: 'total_panjar',
          label: 'Total Panjar',
          sortable: false,
          formatter: (value, key, item) => {
            let summary = 0
            if (item.panjar.length > 0) {
              item.panjar.forEach(item => {
                // summary = summary + (item.nilai_dpp + ((item.nilai_dpp * item.ppn) / 100))
                summary = summary + item.nilai_dpp
                item.biaya_lains.forEach(biayaLain => {
                    summary = summary + biayaLain.biaya
                });

              });

            }
            return 'Rp ' + summary.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          },
        },
        {
          key: 'selisih_beban_panjar',
          label: 'Selisih Beban Panjar',
          sortable: false,
          formatter: (value, key, item) => {
            let totalPanjar = 0
            let totalBeban = 0
            if (item.panjar.length > 0) {
              item.panjar.forEach(item => {
                // totalPanjar = totalPanjar + (item.nilai_dpp + ((item.nilai_dpp * item.ppn) / 100))
                totalPanjar = totalPanjar + item.nilai_dpp
                item.biaya_lains.forEach(biayaLain => {
                    totalPanjar = totalPanjar + biayaLain.biaya
                });

              });
            }
            if (item.rab.length > 0) {
              totalBeban = item.rab.reduce(
                (a, b) =>
                  a +
                  (b['sph'] *
                    (b['sph_kali'] !== 'all'
                      ? b[b['sph_kali']]
                      : b['volume'] * b['periode']) || 0),
                0
              )
            }
            return 'Rp ' + (totalBeban - totalPanjar).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          },
        },
        {
          key: 'margin_beban_panjar',
          label: 'Margin Beban Panjar',
          sortable: false,
          formatter: (value, key, item) => {
            let totalPanjar = 0
            let totalBeban = 0
            if (item.panjar.length > 0) {
              item.panjar.forEach(item => {
                // totalPanjar = totalPanjar + (item.nilai_dpp + ((item.nilai_dpp * item.ppn) / 100))
                totalPanjar = totalPanjar + item.nilai_dpp
                item.biaya_lains.forEach(biayaLain => {
                    totalPanjar = totalPanjar + biayaLain.biaya
                });

              });
            }
            if (item.rab.length > 0) {
              totalBeban = item.rab.reduce(
                (a, b) =>
                  a +
                  (b['sph'] *
                    (b['sph_kali'] !== 'all'
                      ? b[b['sph_kali']]
                      : b['volume'] * b['periode']) || 0),
                0
              )
            }
            return `${((totalPanjar / totalBeban) * 100).toFixed(0)}%`
          },
        },
        { key: 'keterangan', label: 'Keterangan', sortable: false },
        {
          key: 'status_proyek',
          label: 'Status Proyek',
          sortable: false,
          formatter: (value, key, item) => {
            return { id: item.id, status: item.status_proyek }
          },
        },
        
        {
          key: 'dokumen',
          label: 'Status Dokumen',
          sortable: false,
          formatter: (value, key, item) => {
            return item
          },
        },
        { key: 'id', label: 'Aksi', sortable: false },
      ],
      model: {
        id: '',
        nama: '',
        status: 'AKTIF',
      },
    }
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {},
}
</script>
<template>
  <Layout>
    <List
      :fields="fields"
      :model="model"
      :title="title"
      :subtitle="subtitle"
      :crumbs="crumbs"
      :url="url"
      :user="user"
      url-tipe="baut"
      tipe="OLO_BAUT"
    />
  </Layout>
</template>
